import {
  OrderStatusCode,
  OrderProductListItem,
  OrderListUpdateButtonProps,
} from '../interface/interface';
import { getOrderProductDetailsById } from '../service';
import { getNonScriptProducts } from './getNonScriptProducts';

export const UpdateOrderListButton = async (
  props: OrderListUpdateButtonProps,
) => {
  switch (true) {
    case props.val.currentSelectedId + 1 === OrderStatusCode.DISPENSED: {
      props.setOrderId({
        orderId: props.val.orderId,
        invoiceId: props.val.invoiceId,
        orderStatusId: props.statusToRender?.id as number,
      });
      props.setClickedOrder(props.row);

      const productDetails = await getOrderProductDetailsById(
        props.accessToken ?? '',
        String(props.val.orderId),
      );
      const products: Array<OrderProductListItem> =
        typeof productDetails === 'number' ? [] : productDetails;

      if (getNonScriptProducts(products).length) {
        props.setOrderProductsList(products);
        props.setShowPackingSlip(true);
        break;
      }
      props.setModalVisibility(true);
      break;
    }
    case props.val.currentSelectedId === OrderStatusCode.AMENDING_DISPENSE: {
      props.updateOrderStatus({
        orderId: props.val.orderId,
        orderStatusIdToUpdate: OrderStatusCode.READY_FOR_SCAN,
      });
      break;
    }
    case props.val.currentSelectedId + 2 ===
      OrderStatusCode.READY_FOR_SHIPPING: {
      props.setOrderId({
        orderId: props.val.orderId,
        invoiceId: props.val.invoiceId,
        orderStatusId: props.statusToRender?.id as number,
      });
      props.setClickedOrder(props.row);
      if (!props.isPharmacist) {
        props.setShowScanCheck(false);
        props.setModalVisibility(true);
        break;
      }
      const productDetails = await getOrderProductDetailsById(
        props.accessToken ?? '',
        String(props.val.orderId),
      );
      props.setOrderProductsList(
        typeof productDetails === 'number' ? [] : productDetails,
      );
      if (
        productDetails
          ?.filter((x: { orderedQty: number }) => x.orderedQty > 0)
          ?.every(
            (y: { is_verified_from_shopify: boolean }) =>
              y.is_verified_from_shopify,
          )
      ) {
        props.setShowScanCheck(false);
        props.setModalVisibility(true);
        break;
      }
      props.setShowScanCheck(true);
      break;
    }
    case props.val.currentSelectedId + 1 === OrderStatusCode.READY_FOR_SCAN: {
      props.updateOrderStatus({
        orderId: props.val.orderId,
        orderStatusIdToUpdate: OrderStatusCode.READY_FOR_SHIPPING,
      });
      break;
    }
    case props.val.currentSelectedId + 1 === OrderStatusCode.SHIPPED: {
      props.setOrderId({
        orderId: props.val.orderId,
        invoiceId: props.val.invoiceId,
        orderStatusId: OrderStatusCode.SHIPPED,
      });
      if (!props.isPharmacist) {
        props.setShowScanCheck(false);
        props.setModalVisibility(false);
        props.updateOrderStatus({
          orderId: props.val.orderId,
          orderStatusIdToUpdate: OrderStatusCode.SHIPPED,
        });
        break;
      }
      const productDetails = await getOrderProductDetailsById(
        props.accessToken ?? '',
        String(props.val.orderId),
      );
      const products: Array<OrderProductListItem> =
        typeof productDetails === 'number' ? [] : productDetails;
      const isScanCheckDone =
        products.length > 0 &&
        products
          ?.filter((x) => x.orderedQty > 0)
          ?.every((item) => item.is_verified_from_shopify);

      if (isScanCheckDone) {
        props.updateOrderStatus({
          orderId: props.val.orderId,
          orderStatusIdToUpdate: OrderStatusCode.SHIPPED,
        });
      } else {
        props.setClickedOrder(props.row);
        props.setOrderProductsList(products);
        props.setShowScanCheck(true);
      }
      break;
    }
    default: {
      props.updateOrderStatus({
        orderId: props.val.orderId,
        orderStatusIdToUpdate: props.val.currentSelectedId + 1,
      });
      break;
    }
  }
};
